/**
 * A self-balancing line (journal.lines[] with counterAccountId set) always has
 * exactly one of debitField/creditField non-zero — that's the gross amount,
 * and at posting time it expands into a debit leg AND a credit leg of that
 * same gross (36.03 rework's expandLedgerLines). A plain line's raw
 * debitAmount/creditAmount is already the right number for each side.
 *
 * Without this, the header's totalDebitBase/totalCreditBase (header.sumLines
 * over the raw fields) shows a one-line self-balancing entry as lopsided
 * (e.g. "0 debit / 99 credit") even though it posts perfectly balanced —
 * misleading, not a real imbalance. This computes what each line actually
 * contributes to each side: gross on both sides when self-balancing, the
 * plain field otherwise.
 */
const subDualAmount = (data, operation) => {
    const { subEntity, debitField, creditField, conditionField, targetDebitField, targetCreditField } = operation

    if (!data || !data[subEntity] || !Array.isArray(data[subEntity])) {
        return data
    }

    const newSubArray = data[subEntity].map(elem => {
        const debit = Number(elem[debitField]) || 0
        const credit = Number(elem[creditField]) || 0
        const isSelfBalancing = !!elem[conditionField]
        const gross = debit + credit

        return {
            ...elem,
            [targetDebitField]: isSelfBalancing ? gross : debit,
            [targetCreditField]: isSelfBalancing ? gross : credit
        }
    })

    return {
        ...data,
        [subEntity]: newSubArray
    }
}

export default subDualAmount
